import "./App.css";
import Converter from "./Converter";

function App() {
  return (<div className="App">
    <Converter />
  </div>);
}

export default App;